import { INTL_IDS } from '@dmi/shared/redux/Main/messages';

export const DESKTOP_CARD_BUTTON_DICTIONARY = {
  amortization: {
    header: 'See your future payments',
    name: 'amortScheduleCalendar',
    path: '/calculators/amortize',
    text: INTL_IDS.MARKETING_CARDS_AMORTIZATION_TEXT_DESKTOP,
  },
  autopay: {
    header: 'Never miss a payment',
    name: 'autopayMoney',
    path: '/payments/autopay',
    text: INTL_IDS.MARKETING_CARDS_AUTOPAY_TEXT,
  },
  calculator: {
    header: 'Payoff your loan early',
    name: 'calculatorMT',
    path: '/calculators',
    text: INTL_IDS.MARKETING_CARDS_CALCULATOR_TEXT,
  },
  disaster: {
    header: 'Recover after a disaster',
    name: 'disasterUmbrella',
    path: '/help/disasterassistance',
    text: INTL_IDS.MARKETING_CARDS_DISASTER_TEXT,
  },
  documents: {
    desktopLink: '/documents',
    header: 'Looking for a document?',
    name: 'documentsStatements',
    path: '/documents',
    text: INTL_IDS.MARKETING_CARDS_DOCUMENTS_TEXT,
  },
  glossary: {
    header: 'Explore our Glossary',
    name: 'helpDog',
    path: '/help/glossary',
    text: INTL_IDS.MARKETING_CARDS_GLOSSARY_TEXT,
  },
  hardship: {
    header: 'Plan for difficult times',
    name: 'hardshipLighthouseS',
    path: '/help/hardshipassistance',
    text: INTL_IDS.MARKETING_CARDS_HARDSHIP_TEXT,
  },
  helocDraw: {
    header: 'Request HELOC Draw',
    name: 'detailedKey',
    path: '/mortgage/helocdraw',
    text: INTL_IDS.MARKETING_CARDS_HELOCDRAW_TEXT,
  },
  help: {
    header: 'Need Help?',
    name: 'helpDog',
    path: '/help',
    text: INTL_IDS.MARKETING_CARDS_HELP_TEXT,
  },
  learningCenter: {
    header: 'Understand homeownership',
    name: 'helpLearningCenter',
    path: '/help/learningcenter',
    text: INTL_IDS.MARKETING_CARDS_LEARNINGCENTER_TEXT_DESKTOP,
  },
};

export const MOBILE_CARD_BUTTON_DICTIONARY = {
  amortization: {
    header: 'See future payments',
    name: 'calendarLarge',
    nestedScreen: 'Amortize',
    screen: 'Calculators',
    text: INTL_IDS.MARKETING_CARDS_AMORTIZATION_TEXT_MOBILE,
  },
  autopay: {
    header: 'Never miss a payment',
    name: 'autopayMoney',
    nestedScreen: 'AutopayPreConfirmation',
    screen: 'Payments',
    text: INTL_IDS.MARKETING_CARDS_AUTOPAY_TEXT,
  },
  calculator: {
    header: 'Payoff your loan early',
    name: 'calculatorMT',
    screen: 'Calculators',
    text: INTL_IDS.MARKETING_CARDS_CALCULATOR_TEXT,
  },
  documents: {
    header: 'Looking for a document?',
    name: 'documentsStatements',
    screen: 'Documents',
    text: INTL_IDS.MARKETING_CARDS_DOCUMENTS_TEXT,
  },
  escrow: {
    header: 'Set up an escrow account',
    name: 'PiggyBig',
    screen: 'AddEscrow',
    text: INTL_IDS.MARKETING_CARDS_ESCROW_TEXT,
  },
  glossary: {
    header: 'Explore our Glossary',
    name: 'helpDogS',
    screen: 'Glossary',
    text: INTL_IDS.MARKETING_CARDS_GLOSSARY_TEXT,
  },
  hardship: {
    header: 'Plan for difficult times',
    name: 'hardshipLighthouseS',
    nestedScreen: 'HardshipAssistance',
    screen: 'Help',
    text: INTL_IDS.MARKETING_CARDS_HARDSHIP_TEXT,
  },
  helocDraw: {
    header: 'Request HELOC Draw',
    name: 'key',
    screen: 'HelocDrawPreConfirmation',
    text: INTL_IDS.MARKETING_CARDS_HELOCDRAW_TEXT,
  },
  learningCenter: {
    header: 'Understand homeownership',
    name: 'helpLearningCenter',
    nestedScreen: 'LearningCenter',
    screen: 'Help',
    text: INTL_IDS.MARKETING_CARDS_LEARNINGCENTER_TEXT_MOBILE,
  },
};
